import { map, catchError } from 'rxjs/operators';
import { DateService } from '@core/services';
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { environment as env } from '@env/environment';
import { Observable, throwError } from 'rxjs';
import { QueryOptions, Message } from '@models/system';
import { type HttpService } from '@http/services';
import { CustomerMerge } from '@models/domain';

@Injectable({
    providedIn: 'root'
})
export class CustomerMergeService implements HttpService<CustomerMerge> {

    constructor(private http: HttpClient) {}

    fetch(qo: QueryOptions) : Observable<HttpResponse<CustomerMerge[]>> {
        return throwError(() => new Error("Invalid API service call attempt"));
    }

    get(id: string) : Observable<HttpResponse<CustomerMerge>> {
        return throwError(() => new Error("Invalid API service call attempt"));
    }

    post(t: CustomerMerge): Observable<HttpResponse<CustomerMerge>> {
        //return throwError(() => new Error("Invalid API service call attempt"));
        return this.http.post<CustomerMerge>(env.API_URL + '/customer-merges', t, {
            params: {},
            observe: 'response'
        });
    }

    put(t: CustomerMerge): Observable<HttpResponse<Message>> { 
        return throwError(() => new Error("Invalid API service call attempt"));
    }

    delete(id: string) : Observable<HttpResponse<Message>> {
        return throwError(() => new Error("Invalid API service call attempt"));
    }

}
